export default __webpack_public_path__ + "static/media/R5C_8217.7eb2f63a.jpg";